import styled from 'styled-components';
import { color } from '../style/variables.js';
import ResetButtonStyle from '../style/ResetButtonStyle.js';
import media, { hover } from '../style/media.js';

export const Icon = styled.button`
  ${ResetButtonStyle};
  position: relative;
  flex: none;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  transition: 0.3s;
  background-color: ${({ isMatch }) =>
    isMatch ? 'rgba(255, 120, 120, 0.2)' : 'transparent'};
  opacity: 1;
  > img {
    width: 28px;
    height: 28px;
    object-fit: contain;
  }

  ${hover`
    background-color: rgba(155, 155, 155, 0.2);
    opacity: 1;
  `};
`;

export const IconSection = styled.div`
  margin-left: 8px;
  ${media.mobile`
    margin-left: 4px;
  `}
`;

export const TooltipStyle = styled.div`
  min-width: 44px;
  height: 30px;
  padding: 7px;
  border-radius: 8px;
  box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.5);
  background-color: rgba(246, 246, 246, 0.8);
  color: ${color.black};
  font-size: 14px;
  text-align: center;
  white-space: nowrap;
  margin-top: 8px;
  ${media.mobile`
    display: none;
  `}
`;

export const SearchWrapper = styled.div`
  display: none;

  ${media.mobile`
    display: ${({
      $shouldShowSearchOnMobile,
      $shouldShowSearchIfUnauthorizedOnMobile,
    }) =>
      $shouldShowSearchOnMobile || $shouldShowSearchIfUnauthorizedOnMobile
        ? 'flex'
        : 'none'};
  `}
`;

export const NotificationWrapper = styled.div`
  display: flex;

  ${media.mobile`
    display: ${({ $shouldShowNotificationOnMobile }) =>
      $shouldShowNotificationOnMobile ? 'flex' : 'none'};
  `}
`;
